import {StudentAnnualReportActivity} from 'APIs/letrusAPI/studentAnnualReport/types';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import useEvolutionDashboard from 'features/useEvolutionDashboard';
import {Tag, Table} from 'letrus-ui';
import styles from './ActivitiesDetailsTable.module.scss';

interface ActivitiesDetailsTableProps {
  activities: StudentAnnualReportActivity[];
  selectedCompetenceInfo: string;
  view: string;
}

function ActivitiesDetailsTable({
  activities,
  selectedCompetenceInfo,
  view,
}: ActivitiesDetailsTableProps) {
  const {getTrendPropriety} = useEvolutionDashboard();

  return (
    <article className={styles.container}>
      <header>
        <h2 id="activities-table-title">Detalhamento por Atividade</h2>

        {view === 'competence' && (
          <Tag
            variant="readOnly"
            backgroundColor="#e8f2fc"
            mainColor="#1d79e6"
            text={selectedCompetenceInfo}
          />
        )}
      </header>

      <Table.Container
        className={styles.tableContainer}
        aria-labelledby="activities-table-title"
      >
        <Table.Header
          headings={[
            '#',
            'Atividade',
            'Data',
            'Nota',
            'Diferença',
            'Tendência',
          ]}
        />

        <tbody>
          {activities?.map((activity, index) => {
            const trend = getTrendPropriety(
              activity?.grade_details?.grade_difference ?? 0,
            );
            const date = new Date(activity?.end_datetime).toLocaleDateString(
              'pt-BR',
            );

            return (
              <tr key={activity?.review_id}>
                <td>{index + 1}</td>
                <td>{activity?.test_name}</td>
                <td>{date}</td>
                <td>{activity?.grade_details?.points}</td>
                <td style={{color: trend.color}}>
                  {activity?.grade_details?.grade_difference}
                </td>
                <td>
                  <FontAwesomeIcon
                    icon={trend.icon}
                    color={trend.color}
                    size="lg"
                    aria-hidden="true"
                  />
                </td>
              </tr>
            );
          })}
        </tbody>

        <tfoot>
          <tr>
            <td colSpan={6}>Total de {activities?.length} atividades</td>
          </tr>
        </tfoot>
      </Table.Container>
    </article>
  );
}

export default ActivitiesDetailsTable;
